// extracted by mini-css-extract-plugin
export default {"container":"DnDBoard_container__189OY","columns":"DnDBoard_columns__Z6ClD","loader":"DnDBoard_loader__ekEN4"};